'use client'

import { ButtonLink } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import {
  Icon,
  Row,
  SegmentedGroup,
  SegmentedGroupItem,
} from '@repo/ui/components'

export interface ProjectsDetailCTAProps {
  onChange: (value: string) => void
  tab: string
  children?: React.ReactNode
}

export const ProjectsDetailCTA = (props: ProjectsDetailCTAProps) => {
  const { onChange, tab, children } = props
  const { t } = useTranslate()

  const handleChangeRange = (value: string) => {
    onChange(value)
  }

  const timeRanges = [
    { label: t('common_details'), value: 'detail' },
    { label: t('common_trade'), value: 'trade' },
  ]

  return (
    <Row className='fixed border border-b-neutral-light top-0 bg-neutral-surface-light z-10 justify-between h-fit gap-md p-xs left-0 w-full'>
      <ButtonLink
        variant='transparent'
        color='neutral'
        size='md'
        href='/rwa'
        startIcon={<Icon name='ArrowRightLine' size='md' />}
        aria-label='Back to Projects'
      />

      <SegmentedGroup
        value={tab}
        onValueChange={handleChangeRange}
        color='neutral'
        size='sm'
      >
        {timeRanges.map((item) => (
          <SegmentedGroupItem key={item.value} value={item.value}>
            {item.label}
          </SegmentedGroupItem>
        ))}
      </SegmentedGroup>
      <div className='w-[32px]'>{children}</div>
    </Row>
  )
}
